import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import AnnouncementIcon from 'components/ReusableComponents/Icons/Announcement'
import DepartingTomorrowIcon from 'components/ReusableComponents/Icons/DepartingTomorrow'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import NoMessages from 'components/ReusableComponents/Messaging/NoMessages'
import RefreshIcon from 'components/ReusableComponents/RefreshIcon'
import AudienceInfoBar from 'features/Announcements/AudienceInfoBar'
import ConversationBubble from 'features/Announcements/ConversationBubble'
import DateDivider from 'features/Announcements/DateDivider'
import EditTextDialog from 'features/Announcements/EditTextDialog'
import ArrivingTodayIcon from 'features/Announcements/icons/ArringToday'
import DepartingTodayIcon from 'features/Announcements/icons/DepartingToday'
import InHouseIcon from 'features/Announcements/icons/InHouseGuests'
import SendMessageBar from 'features/Announcements/SendMessageBar'
import { customCampaignStatusTypes } from 'features/CustomCampaigns/helpers'
import moment from 'moment-timezone'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { useToasts } from 'react-toast-notifications'
import announcementApi from 'services/api/announcement'

import styles from './Announcements.module.scss'
import Sidebar from './Sidebar'

export const inPropertyAudienceTypes = {
  InHouse: 'InHouse',
  ArrivingToday: 'ArrivingToday',
  DepartingToday: 'DepartingToday',
  DayBeforeCheckOut: 'DayBeforeCheckOut'
}

export const inPropertyAudiences = {
  InHouse: {
    name: 'In-house',
    description: 'Guests staying in-property',
    icon: InHouseIcon,
    accentColor: '#4299E1'
  },
  ArrivingToday: {
    name: 'Arriving today',
    description: 'Guest will check-in today',
    icon: ArrivingTodayIcon,
    accentColor: '#E94BA7'
  },
  DepartingToday: {
    name: 'Departing today',
    description: 'Guests will check-out today',
    icon: DepartingTodayIcon,
    accentColor: '#48BB78'
  },
  DayBeforeCheckOut: {
    name: 'Departing tomorrow',
    description: 'Guests will check-out tomorrow',
    icon: DepartingTomorrowIcon,
    accentColor: '#F59E0B'
  }
}

const Announcements = () => {
  const { audience } = useParams()

  const timeZoneId = useSelector(s => s.hotelDetails.ianaTimeZoneId)

  const [showingDialog, setShowingDialog] = useState(false)
  const [announcementType, setAnnouncementType] = useState()

  const [isLoading, setIsLoading] = useState(true)

  function handleClickSchedule() {
    setAnnouncementType('schedule')
    setShowingDialog(true)
  }

  function handleClickMessageNow() {
    setAnnouncementType('immediate')
    setShowingDialog(true)
  }

  const [messages, setMessages] = useState([])
  const [isLoadingMessages, setIsLoadingMessages] = useState(false)

  const { addToast } = useToasts()

  const [audienceSizes, setAudienceSizes] = useState()

  const [newMessageOverWrites, setNewMessageOverWrites] = useState([])

  const [defaultText, setDefaultText] = useState('')

  useEffect(() => {
    setNewMessageOverWrites([])
  }, [audience])

  function handleMessageSent(overwrites) {
    setNewMessageOverWrites(overwrites)
    setIsLoadingMessages(true)
    setMessages([])
    announcementApi
      .getMessages(audience)
      .then(data => {
        setMessages(data.items)
      })
      .catch(() => {
        addToast(`Couldn't get earlier notifications`, { appearance: 'error' })
      })
      .finally(() => {
        setIsLoadingMessages(false)
        // setNewContentId(null)
        setNewMessageOverWrites([])
        if (Element.prototype.scrollIntoView && footerRef.current) {
          setTimeout(() => {
            if (footerRef.current) {
              footerRef.current.scrollIntoView()
            }
          }, 0)
        }
      })
  }

  const footerRef = useRef()

  useEffect(() => {
    if (audience) {
      setIsLoading(true)
      announcementApi
        .getAudiences()
        .then(data => {
          setAudienceSizes(data.guests)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [audience])

  useEffect(() => {
    announcementApi.getDefaultText({ audience }).then(data => {
      setDefaultText(data.defaultTextContent)
    })
  }, [audience])

  const [checkIndex, setCheckIndex] = useState(0)
  const [lastChecked, setLastChecked] = useState()

  useEffect(() => {
    function updateResults() {
      announcementApi
        .getMessages(audience)
        .then(data => {
          setMessages([...data.items])
        })
        .catch(() => {
          addToast(`Couldn't announcements`, { appearance: 'error' })
        })
        .finally(() => {
          setLastChecked(new Date().toISOString())
        })
    }

    if (
      messages.find(a => a.customDeliveryStatus === customCampaignStatusTypes.Approved)
    ) {
      const scheduledUpdate = setTimeout(() => {
        updateResults()
      }, 30000)

      return () => clearTimeout(scheduledUpdate)
    }
  }, [messages, audience, addToast])

  useEffect(() => {
    setIsLoadingMessages(true)
    setMessages([])
    announcementApi
      .getMessages(audience)
      .then(data => {
        setMessages([...data.items])
      })
      .catch(() => {
        addToast(`Couldn't get earlier notifications`, { appearance: 'error' })
      })
      .finally(() => {
        setIsLoadingMessages(false)
        if (Element.prototype.scrollIntoView && footerRef.current) {
          setLastChecked(new Date().toISOString())
          setTimeout(() => {
            if (footerRef.current) {
              footerRef.current.scrollIntoView()
            }
          }, 0)
        }
      })
  }, [audience, addToast, checkIndex])

  useEffect(() => {
    document.querySelector('body').classList.add('darkBody')

    return () => {
      document.querySelector('body').classList.remove('darkBody')
    }
  }, [])

  return (
    <div className={styles.wrapper}>
      <CustomHeader title="Announcements" width={1300} />
      <Sidebar />
      <div className={styles.chatContainer}>
        {!audience && <NoMessages>Select a guest category to message</NoMessages>}
        {audience && (
          <div className={styles.topBar}>
            <AudienceInfoBar
              audience={audience}
              audienceSize={audienceSizes?.[audience]?.total}
              totalEligibleForText={
                audienceSizes?.[audience]?.totalEligiblePhoneNumberCount
              }
            />
            <SendMessageBar
              audience={audience}
              onClickSchedule={handleClickSchedule}
              onClickMessageNow={handleClickMessageNow}
              canSendMessageNow={
                audienceSizes?.[audience]?.totalEligiblePhoneNumberCount > 0
              }
              //canSendMessageNow={true}
            />
          </div>
        )}
        {audience && (
          <>
            {messages.length > 0 && (
              <>
                <div className={styles.messagesHolder}>
                  <div className={styles.bubblesContainer}>
                    {messages
                      .filter(
                        m => m.customDeliveryStatus !== customCampaignStatusTypes.Deleted
                      )
                      .sort((a, b) => new Date(a.addedOn) - new Date(b.addedOn))
                      .reduce((pm, m, i, arr) => {
                        return [
                          ...pm,
                          <DateDivider
                            key={'d' + m.contentId}
                            prevMessage={arr[i - 1] || null}
                            currentMessage={m}
                          />,
                          <ConversationBubble
                            key={m.contentId}
                            messageTemplate={m.messageTemplate}
                            messageMediaUrls={m.messageMediaUrls}
                            deliveryRemaining={m.deliveryRemaining}
                            deliverySize={m.deliverySize}
                            addedBy={m.addedBy}
                            audience={audience}
                            contentId={m.contentId}
                            deliveryStartDate={m.deliveryStartDate}
                            deliveryFinishDate={m.deliveryFinishDate}
                            addedOn={m.addedOn}
                            customDeliveryStatus={m.customDeliveryStatus}
                            isNewMessage={newMessageOverWrites.find(
                              o => o.contentId === m.contentId
                            )}
                            {...newMessageOverWrites.find(
                              o => o.contentId === m.contentId
                            )}
                          />
                        ]
                      }, [])}
                    <div ref={footerRef}></div>
                  </div>
                  <div className={styles.lastUpdatedBar}>
                    <button onClick={() => setCheckIndex(i => i + 1)}>
                      <RefreshIcon />
                    </button>
                    <span>
                      Last updated on{' '}
                      {moment(lastChecked).tz(timeZoneId).format('h:mm A')} (hotel time)
                    </span>
                  </div>
                </div>
              </>
            )}
            {messages.length === 0 && !isLoadingMessages && (
              <div className={styles.emptyMessagesHolder}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                    fontSize: 17,
                    color: '#8a8e92',
                    flexDirection: 'column'
                  }}
                >
                  <AnnouncementIcon
                    fill="#A8ADB2"
                    style={{ fontSize: 50, marginBottom: 10, marginTop: -20 }}
                  />
                  You'll see the past announcements here.
                </div>
              </div>
            )}
            {isLoadingMessages && (
              <div className={styles.emptyMessagesHolder}>
                <LoadingIndicator />
              </div>
            )}
            {showingDialog && !isLoading && (
              <EditTextDialog
                onClose={() => setShowingDialog(false)}
                onMessageSent={handleMessageSent}
                announcementType={announcementType}
                audience={audience}
                totalEligibleForText={
                  audienceSizes?.[audience]?.totalEligiblePhoneNumberCount
                }
                defaultText={defaultText}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default Announcements
